<template>
  <v-app id="login" class="light-blue darken-4">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="/static/logo-cusam.png"
                    alt="Vue Material Admin"
                    width="350"
                    height="120"
                  />
                  <h1 class="flex my-4 title">Sistema de control Bibiloteca</h1>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                    v-model="model.username"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    type="password"
                    v-model="model.password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block color="info" @click="login" :loading="loading">Iniciar Sesión</v-btn>
              </v-card-actions>
            </v-card>
            <v-snackbar v-model="snackbar" :timeout="timeout" :color="color">
              {{ text }}
              <v-btn color="red" text @click="snackbar = false">Cerrar</v-btn>
            </v-snackbar>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { debuglog } from "util";
export default {
  data: () => ({
    loading: false,
    snackbar: false,
    text: "",
    timeout: 5000,
    color: "",
    model: {
      username: "",
      password: ""
    }
  }),

  methods: {
    login(e) {
      e.preventDefault();
      this.loading = true;
      this.$store.dispatch("obtainToken", this.model, this.model);
      setTimeout(
        function() {
          let token = localStorage.getItem("t");
          if (token !== null) {
            this.$router.push("/dashboard");
          } else {
            this.loading = false;
            this.snackbar = true;
            this.text = "Las credenciales proporcionadas no son válidas";
            this.color = "error";
          }
        }.bind(this),
        1000
      );
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
